import config from "@/config";
import * as utils from "@/utils";
import store from "@/store";

export async function getScripts(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["Atoms"](params);
  } else {
    console.log("getScripts: cmd mode");
    let data = await utils.$get(`/api/atoms/?${params}`);
    return new Promise((resolve, reject) => {
      resolve(data);
    });
  }
}
export async function getScriptsTags() {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["AtomsTags"]();
  } else {
    let data = await utils.$get(`/api/atoms/tags/`);
    return new Promise((resolve, reject) => {
      resolve(data);
    });
  }
}

export async function getSingleAtom(hash) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return { Script: m["SingleAtom"](hash) };
  } else {
    let data = await utils.$get(`/api/atom/${hash}/info`);
    return new Promise((resolve, reject) => {
      resolve(data);
    });
  }
}

export async function getTriggers(query, pageNum, pageSize) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["Triggers"](query, pageNum, pageSize);
  } else {
    let data = await utils.$get(`/api/triggers/`);
    return new Promise((resolve, reject) => {
      resolve(data);
    });
  }
}

export async function getSingleTrigger(hash) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["SingleTrigger"](hash);
    return { Trigger: res };
  } else {
    let data = await utils.$get(`/api/trigger/${hash}`);
    return new Promise((resolve, reject) => {
      resolve(data);
    });
  }
}

export async function saveTrigger(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["SaveTrigger"](params);
    return res;
  } else {
    let data = await utils.$post("/api/trigger/save/", params);
    return data;
  }
}

export async function newTask(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["NewTask"](params);
    return res;
  } else {
    let data = await utils.$post("/api/tasks/save/", params);
    return data;
  }
}

export async function runTask(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["RunTask"](params);
    return res;
  } else {
    return utils.$post("/api/tasks/run/", params);
  }
}

export async function updateTaskSchedule(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["UpdateTaskSchedule"](params);
    return res;
  } else {
    return utils.$post("/api/tasks/schedule/", params);
  }
}


export async function removeTask(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["RemoveTask"](params);
    return res;
  } else {
    return utils.$post("/api/tasks/remove/", params);
  }
}

export async function pauseTask(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["PauseTask"](params);
    return res;
  } else {
    return utils.$post("/api/tasks/pause/", params);
  }
}

export async function stopTask(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["StopTask"](params);
    return res;
  } else {
    return utils.$post("/api/tasks/stop/", params);
  }
}

export async function getTasks(query, offset) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["Tasks"](query, offset);
  } else {
    return utils.$get(
      `/api/tasks/?q=${query}&offset=${offset}` //&web=${this.showWebTasks`}
    );
  }
}

export async function getSingleTask(taskID) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["SingleTask"](taskID);
    return { Task: res };
  } else {
    return utils.$get(`/api/tasks/${taskID}/info/`);
  }
}

export async function getTaskLogs(taskID) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["TaskLogs"](taskID);
    return res;
  } else {
    let data = await utils.$get(`/api/task/${taskID}/logs/`);
    return data;
  }
}

export async function loadTaskTablesLabels(taskID, scriptHash) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["TaskTablesLabels"](taskID, scriptHash);
    return res;
  } else {
    let data = await utils.$get(
      `/api/tasks/${taskID}/tables/labels/?atom=${scriptHash}`
    );
    return data;
  }
}
export async function loadTaskTableData(taskID, scriptHash) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["TaskTablesLabels"](taskID, scriptHash);
    return res;
  } else {
    let data = await utils.$get(
      `/api/tasks/${taskID}/tables/labels/?atom=${scriptHash}`
    );
    return data;
  }
}

export async function loadTaskTableDataRecord(taskID, atom, hash) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["TaskTablesLabels"](taskID, atom);
    return res;
  } else {
    let data = await utils.$get(
      `/api/tasks/${taskID}/tables/labels/?atom=${atom}&hash=${hash}`
    );
    return data;
  }
}

export async function getTaskSchedule(taskID) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["TaskSchedule"](taskID);
    if (res.status === "error") {
      return null;
    }
    return { Schedule: res };
  } else {
    let data = await utils.$get(`/api/task/${taskID}/schedule/`);
    return data;
  }
}

export async function newScript(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["NewAtom"](params);
    if (res.status === "error") {
      return null;
    }
    return res;
  } else {
    let data = await utils.$post("/api/atoms/save/", params);
    return data;
  }
}

export async function removeScript(id) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["RemoveAtom"](hash);
    return res;
  } else {
    return utils.$post("/api/atoms/remove/", { id: id });
  }
}

export async function getFiles(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["Files"](params);
  } else {
    let data = await utils.$get(`/api/storage/files/?${params}`);
    return data;
  }
}

export async function getFile(id) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["File"](id);
  } else {
    let data = await utils.$get(`/api/storage/file/?id=${id}`);
    return data;
  }
}

export async function getFileTypes() {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["StorageFileTypes"]();
  } else {
    let data = await utils.$get(`/api/storage/files/types/`);
    return data;
  }
}
export async function editFile(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["EditFile"](params);
    return res;
  } else {
    return utils.$post("/api/storage/editFile/", params);
  }
}

export async function getKVSpaces() {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["KVSpaces"]();
  } else {
    let data = await utils.$get(`/api/storage/kv/spaces/`);
    return data;
  }
}

export async function getKVSpaceData(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["KVSpaceData"](params);
  } else {
    let data = await utils.$get(`/api/storage/kv/space/data/?${params}`);
    return data;
  }
}

export async function removeFile(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["RemoveFile"](params);
    return res;
  } else {
    let data = await utils.$post("/api/storage/removeFile", params);
    return data;
  }
}

export async function executeLuaCode(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["ExecuteLuaCode"](params);
  } else {
    let data = await utils.$post("/api/utils/execute/", params);
    return data;
  }
}

export async function getLuaCode() {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["LuaCode"]();
  } else {
    let data = await utils.$get("/api/utils/code/");
    return data;
  }
}

export async function saveLuaCode(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["SaveLuaCode"](params);
  } else {
    let data = await utils.$post("/api/utils/code/", params);
    return data;
  }
}

export async function sendHTTPRequest(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["SendHTTPRequest"](params);
    return { Response: res };
  } else {
    let data = await utils.$post("/api/webengine/send/", params);
    return data;
  }
}

export async function saveHTTPRequest(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["SaveHTTPRequest"](params);
  } else {
    let data = await utils.$post("/api/webengine/save/", params);
    return data;
  }
}
export async function getSettings() {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["Settings"]();
    store.dispatch("updateSettings", res);
    return { Settings: res };
  } else {
    let data = await utils.$get("/api/settings/");
    store.dispatch("updateSettings", data["Settings"]);
    return data;
  }
}

export async function getAbout() {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["About"]();
    return res;
  } else {
    return utils.$get("/api/about/");
  }
}

export async function getLists(query, pageNum, pageSize) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["Lists"](query, pageNum, pageSize);
  } else {
    return utils.$get(`/api/lists/`);
  }
}

export async function getScopes(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["Scopes"](params);
  } else {
    let data = await utils.$get(`/api/scopes/?${params}`);
    return data;
  }
}

export async function addScope(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["AddScope"](params);
  } else {
    let data = await utils.$post("/api/scopes/add/", params);
    return data;
  }
}

export async function removeScope(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["RemoveScope"](params);
  } else {
    let data = await utils.$post("/api/scopes/remove/", params);
    return data;
  }
}

export async function addAssets(assets) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["AddAssets"](assets);
  } else {
    let data = await utils.$post("/api/assets/add/", assets);
    return data;
  }
}

export async function removeAssets(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["RemoveAssets"](params);
  } else {
    let data = await utils.$post("/api/assets/remove/", params);
    return data;
  }
}

export async function getAssets(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["Assets"](params);
  } else {
    let data = await utils.$get(`/api/assets/?${params}`);
    return data;
  }
}

export async function getAssetsExtra() {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["AssetsExtra"]();
  } else {
    let data = await utils.$get(`/api/assets/extra/`);
    return data;
  }
}

export async function getAssetsTree(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["AssetsTree"](params);
  } else {
    let data = await utils.$get(`/api/assets/tree/?${params}`);
    return data;
  }
}

/// CLOUD SYNC

export async function cloudSync(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["CloudSync"](params);
  } else {
    let data = await utils.$post("/api/cloud/sync/", params);
    return data;
  }
}

export async function getCloudSyncStatus() {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    return m["CloudSyncStatus"](params);
  } else {
    let data = await utils.$get("/api/cloud/sync/");
    return data;
  }
}

export async function updateSettings(params) {
  if (config.desktop_mode) {
    const m = await import("@/../wailsjs/go/api/APIC");
    let res = await m["UpdateSettings"](params);
    return res;
  } else {
    let data = await utils.$post("/api/settings/", params);
    return data;
  }
}



// WEBPACK FOOTER //
// ./src/api.js